import "./LessonsEmbed.css";

import * as m from "../../../model/model";

import React, { useEffect, useState } from "react";
import { RootState, useAppSelector } from "../../../store";

interface Props {
  lesson?: m.Lesson;
}

function LessonsEmbedComponent(props: Props) {
  const lesson = useAppSelector((state: RootState) => state.lesson.lesson);
  const [embed, setEmbed] = useState("");

  useEffect(() => {
    // only update if embed really changed
    if (lesson && lesson.embed !== embed) {
      setEmbed(lesson.embed);
    }
  }, [lesson, embed]);

  return (
    <div className="lessons-embed">
      <div className="overlay-hack" />
      <div className="embed" dangerouslySetInnerHTML={{ __html: embed }}></div>
      <div className="stuff" />
    </div>
  );
}

// Wrap in React.memo to avoid unnecessary re-renders
export default React.memo(LessonsEmbedComponent);
